import {
  AutoComplete,
  DateInput,
  FormInput,
  QPFQuickRegisterForm,
  QPJQuickRegisterForm,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useEffect, useMemo } from "react";
import { listMainGenerics } from "../../../../../services/generic.service";
import { TDonorsForm } from "../donorsSchema";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CNPJMask, CPFMask } from "../../../../../utils/maks";

const translationPath = "page.4uDonation.donors.form.";

export const PersonalData = memo(() => {
  const { t } = useTranslation();

  const { control, setValue } = useFormContext<TDonorsForm>();

  const entity = useWatch({ control, name: "donorType" });
  const individual = useWatch({ control, name: "individual" });
  const legalEntity = useWatch({ control, name: "legalEntity" });

  const gendersIdentifier = useMemo(() => ({ identifier: "Gender" }), []);

  const documentLabel = useMemo(
    () =>
      entity?.code === "1"
        ? t(translationPath + "document.cpf") || "CPF"
        : t(translationPath + "document.cnpj") || "CNPJ",
    [entity, t]
  );

  const documentMask = useMemo(
    () => (entity?.code === "1" ? CPFMask.mask : CNPJMask.mask),
    [entity]
  );

  const dateLabel = useMemo(
    () =>
      entity?.code === "1"
        ? t(translationPath + "birth_date") || "Data de Nascimento"
        : t(translationPath + "incorporation_date") || "Data de Fundação",
    [entity, t]
  );

  useEffect(() => {
    if (!individual) return;
    setValue("name", individual.individualName || "");
    setValue("document", individual.document || "");
    if (individual.birthDate) {
      setValue(
        "birthDateField",
        new Date(individual.birthDate.replace(/-/g, "/"))
      );
    }
  }, [individual, setValue]);

  useEffect(() => {
    if (!legalEntity) return;
    setValue("name", legalEntity.corporateName || "");
    setValue("document", legalEntity.document || "");
  }, [legalEntity, setValue]);

  return (
    <>
      {entity?.code === "1" && (
        <>
          <Grid item xs={12} sm={6}>
            <AutoComplete
              name="gender"
              request={listMainGenerics}
              params={gendersIdentifier}
              label={t(translationPath + "gender") || "Gênero"}
              getOptionLabel={(option) => option.name}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <QPFQuickRegisterForm
              name="individual"
              label={t(translationPath + "individual_person") || "Individual"}
            />
          </Grid>
        </>
      )}

      {entity?.code === "2" && (
        <Grid item xs={12} sm={12}>
          <QPJQuickRegisterForm
            name="legalEntity"
            label={t(translationPath + "legal_entity") || "Legal entity"}
          />
        </Grid>
      )}

      <Grid item xs={12} sm={12}>
        <FormInput
          name="name"
          label={t(translationPath + "name") || "Nome"}
          fullWidth
          size="small"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormInput
          name="document"
          label={documentLabel}
          fullWidth
          size="small"
          mask={documentMask}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <DateInput name="birthDateField" label={dateLabel} />
      </Grid>
    </>
  );
});
